export const WORDS = ['102624']
